var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 0.3125C24.6802 0.3125 25.9688 1.60107 25.9688 3.15625V14.5312C25.9688 16.1309 24.6802 17.375 23.125 17.375H3.21875C1.61914 17.375 0.375 16.1309 0.375 14.5312V3.15625C0.375 1.60107 1.61914 0.3125 3.21875 0.3125H23.125ZM13.1719 13.1094C15.5269 13.1094 17.4375 11.1987 17.4375 8.84375C17.4375 6.48877 15.5269 4.57812 13.1719 4.57812C10.7725 4.57812 8.90625 6.48877 8.90625 8.84375C8.90625 11.1987 10.7725 13.1094 13.1719 13.1094Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.5400dfe1965fa15efa3ffa6952358585.svg";
export { ForwardRef as ReactComponent };